import { motion } from "framer-motion";

const testids = ["stat-years", "stat-mandates", "stat-compliance", "stat-ide-uid"];

export const Stats = ({ t }) => (
  <section id="stats" className="py-28 bg-[#0A101D]">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.6 }}
        className="mb-16"
      >
        <p className="text-xs tracking-[0.35em] uppercase font-mono text-[#E2C376] mb-5 flex items-center gap-3">
          <span className="w-10 h-px bg-[#D4AF37]" /> {t.stats.eyebrow}
        </p>
        <h2 className="font-serif text-2xl sm:text-3xl lg:text-4xl text-slate-50 tracking-tight">{t.stats.title}</h2>
      </motion.div>

      <div className="grid grid-cols-2 lg:grid-cols-4 border-t border-l border-[#D4AF37]/15">
        {t.stats.items.map((s, i) => (
          <motion.div
            key={testids[i]}
            data-testid={testids[i]}
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ duration: 0.6, delay: i * 0.1 }}
            className="border-r border-b border-[#D4AF37]/15 p-8 lg:p-12 hover:bg-[#111A2E] transition-colors duration-500"
          >
            <div className="font-serif text-4xl lg:text-5xl text-[#D4AF37] mb-3">{s.value}</div>
            <div className="text-xs uppercase tracking-[0.2em] text-slate-400 font-mono">{s.label}</div>
          </motion.div>
        ))}
      </div>
    </div>
  </section>
);
